import classNames from "classnames/bind";
import { Button, EventPricePills, Image } from "@components";
import { EventsByTaxonomyQuery } from "@graphqlTypes";
import { getDateRange } from "@/core/utils";

import styles from './ListingEventsFull.module.scss';
import { usePageWrapperData } from "@/providers/PageWrapperContext";
const cx = classNames.bind(styles);

type ItemProps = EventsByTaxonomyQuery['events']['nodes'][number];
type InfoPillsProps = {
  date: string;
  className?: string;
  pricingType?: ItemProps['eventData']['pricingType'];
  price?: ItemProps['eventData']['price'];
};

const InfoPills = ({ date, className, pricingType, price }: InfoPillsProps) => {
  return (
    <div className={cx(["info-pills", className])}>
      <span className={cx("date", "pill")}>{date}</span>
      <EventPricePills pricingType={pricingType} price={price} />
    </div>
  );
}

export default function ListingEventsFullItem(props: ItemProps) {
  const { uri, title, eventTypes, featuredEventImage, eventData: { startDate, endDate, ticketLink, price, pricingType } } = props;
  const { labels } = usePageWrapperData();
  const date = getDateRange(startDate, endDate);
  const { membersOnly } = labels || {};
  const isMembersOnly = eventTypes.nodes.some(type => type.slug === 'members-only');
  return (
    <div className={cx("listing-events-full-item")}>
      <div className={cx("image")}>
        <Image image={featuredEventImage} />
      </div>
      <div className={cx("content")}>
        <div className={cx("content__wrapper")}>
          {isMembersOnly && <p className={cx("eyebrow-l", "eyebrow")}>{membersOnly}</p>}
          <h3 className={cx("title", "title-lc-m")}>{title}</h3>
          <InfoPills date={date} price={price} pricingType={pricingType} />
          <div className={cx("buttons")}>
            <Button ariaLabel={`Details - ${title}`} label="Details" noIcon={true} url={uri} />
            {ticketLink && <Button label="Get Tickets" target="_blank" url={ticketLink} />}
          </div>
        </div>
        <InfoPills date={date} className={cx("info-pills--desktop")} pricingType={pricingType} price={price} />
      </div>
    </div>
  )
}